<template>
  <section class="galeria-card">
    <!-- Título y descripción -->
    <div class="header-content">
      <h2 class="titulo">Galería del Local</h2>
      <p class="descripcion">Explora las imágenes de nuestro local y descubre nuestro espacio.</p>
    </div>

    <!-- Galería de imágenes -->
    <div class="galeria">
      <div 
        v-for="(foto, index) in fotos" 
        :key="index" 
        class="foto-container" 
        @click="openModal(index)"
      >
        <img :src="foto" :alt="'Foto del local ' + (index + 1)" class="foto"/>
        <div class="scan-overlay"></div>
      </div>
    </div>

    <!-- Modal para ver imagen grande (Estilo Oscuro) -->
    <div v-if="modalVisible" class="modal" @click="closeModal">
      <span class="cerrar" @click="closeModal">&times;</span>
      
      <button v-if="currentIndex > 0" class="nav-btn prev" @click.stop="prevFoto">
        &#10094;
      </button>
      
      <div class="modal-image-wrapper" @click.stop>
        <img :src="fotos[currentIndex]" class="modal-foto" />
      </div>
      
      <button v-if="currentIndex < fotos.length - 1" class="nav-btn next" @click.stop="nextFoto">
        &#10095;
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "JeanInformaticaEmpresa",
  data() {
    return {
      fotos: [
        require('@/assets/Img/Empresas/local-frontal.png'),
        require('@/assets/Img/Empresas/local-3.png'),
        require('@/assets/Img/Empresas/local-1.png'),
        require('@/assets/Img/Empresas/local-2.png'),
        require('@/assets/Img/Empresas/local-5.png')
      ],
      modalVisible: false,
      currentIndex: 0,
    };
  },
  methods: {
    openModal(index) {
      this.currentIndex = index;
      this.modalVisible = true;
      document.body.style.overflow = 'hidden'; // Evita el scroll del fondo
    },
    closeModal() {
      this.modalVisible = false;
      document.body.style.overflow = 'auto'; // Devuelve el scroll
    },
    prevFoto() {
      if (this.currentIndex > 0) this.currentIndex--;
    },
    nextFoto() {
      if (this.currentIndex < this.fotos.length - 1) this.currentIndex++;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;800&display=swap');

/* ===== SECCIÓN PRINCIPAL ===== */
.galeria-card {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 2rem;
  text-align: center;
  background-color: #030812; /* Fondo oscuro tecnológico */
  font-family: 'Poppins', sans-serif;
  overflow: hidden;
  isolation: isolate;
}

/* Rejilla sutil en el fondo de la sección */
.galeria-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 229, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 229, 255, 0.02) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(circle at center, #000 20%, transparent 80%);
  -webkit-mask-image: radial-gradient(circle at center, #000 20%, transparent 80%);
  pointer-events: none;
  z-index: 0;
}

.header-content {
  position: relative;
  z-index: 10;
  margin-bottom: 3rem;
}

.titulo {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 1rem;
  text-shadow: 0 0 20px rgba(0, 229, 255, 0.3);
}

.descripcion {
  font-size: 1.05rem;
  color: #b9c9d9;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ===== GALERÍA (CUADRÍCULA) ===== */
.galeria {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  justify-content: center;
}

.foto-container {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(0, 229, 255, 0.15);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  aspect-ratio: 4 / 3;
}

/* Efecto de resplandor cian al pasar el mouse */
.foto-container:hover {
  transform: translateY(-5px);
  border-color: rgba(0, 229, 255, 0.6);
  box-shadow: 0 10px 30px rgba(0, 229, 255, 0.15);
}

/* La imagen en sí */
.foto {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
  filter: brightness(0.85); /* Un poco oscura para que resalte el efecto */
}

.foto-container:hover .foto {
  transform: scale(1.08);
  filter: brightness(1);
}

/* Línea de escaneo que cruza la imagen */
.scan-overlay {
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 229, 255, 0.2), transparent);
  transition: top 0.6s ease;
  pointer-events: none;
}

.foto-container:hover .scan-overlay {
  top: 100%;
}

/* ===== MODAL DE IMAGEN ===== */
.modal {
  position: fixed;
  inset: 0;
  background: rgba(3, 8, 18, 0.95); /* Fondo casi negro */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  overflow: hidden;
}

.modal-image-wrapper {
  position: relative;
  max-width: 90%;
  max-height: 85vh;
  border-radius: 12px;
  border: 2px solid rgba(0, 229, 255, 0.3);
  box-shadow: 0 0 50px rgba(0, 229, 255, 0.15);
  overflow: hidden;
  animation: zoomIn 0.3s ease-out forwards;
}

.modal-foto {
  width: 100%;
  height: 100%;
  max-height: 85vh;
  object-fit: contain;
  display: block;
}

@keyframes zoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* Botón de cerrar */
.cerrar {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 3rem;
  color: #ffffff;
  cursor: pointer;
  z-index: 2010;
  transition: color 0.3s ease, transform 0.3s ease;
  line-height: 1;
}

.cerrar:hover {
  color: #00e5ff;
  transform: scale(1.1);
}

/* Botones de navegación (Flechas) */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(10, 18, 30, 0.7);
  color: #00e5ff;
  border: 1px solid rgba(0, 229, 255, 0.3);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2010;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  background: #00e5ff;
  color: #030812;
  box-shadow: 0 0 20px rgba(0, 229, 255, 0.5);
}

.prev { left: 30px; }
.next { right: 30px; }

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .galeria-card {
    padding: 3rem 1rem;
  }
  
  .galeria {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
  }
  
  .titulo { font-size: 2rem; }
  
  .nav-btn {
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }
  
  .prev { left: 10px; }
  .next { right: 10px; }
  
  .modal-foto {
    max-width: 100%;
  }
}
</style>